import ApiService from "../api";

const firstCheck = "Estou ciente que o reembolso será recusado, caso a reserva não esteja cancelada e " +
"o número do cartão de crédito não seja informado na solicitação (para emissões internacionais). " + 
"A obrigatoriedade do numero do cartão é uma exigência da Cia aérea.";
    

const secondCheck = "Estou ciente de que os reembolsos 24 horas devem ser obrigatoriamente solicitados por meio do formulário disponível " +
"no seguinte caminho: https://consolidadora.flytour.com.br/formulario-reembolso/, selecionando a opção ‘Compra dentro de 24 horas’. "

const thirtyCheck = "Estou ciente que o(s) reembolso(s) em questão será(ão) processado(s) de acordo com as regras " +
"tarifárias da companhia aérea. Em caso de dúvidas sobre regras, contate nosso atendimento previamente à solicitação."

class ReembolsoService extends ApiService {

    static get firstCheck(){
        return firstCheck;
    }

    static get secondCheck(){
        return secondCheck;
    }
    
    static get thirtyCheck(){
        return thirtyCheck;
    }
    constructor(){
        super('/portal/solicitacao')
    }

    salvar(solicitacao){
        
        return this.post('/saveSolicitacao', solicitacao)
    }

    listar(filtro){
        return this.post('/listarSolicitacoes', filtro)
    }

    enviarEmails(solicitacoes){
        return this.post('/sendEmail', solicitacoes)
    }

    pegarUsuarioSolicitacao(codemp){
        return this.post("/userSolicitacao", codemp)
    }

}

export default ReembolsoService;